import TransactionsList from "../../components/Payment/TransactionsList";
import paymentService from "../../api/paymentService";
import { Transaction } from "./models";
import { useAPI } from "../../api/api";
import { Box, Skeleton, Typography, Card, List } from "@mui/material";
import ManageCard from "./ManageCard";
import { VirtualCardResponse } from "../../types/paymentTypes";
import { getVirtualCard } from "../../api/paymentMethodsService";
import { useTranslation } from "react-i18next";

function CardBalanceAndHistory() {
  const { t } = useTranslation();

  const { loading: loadingTransactions, data: transactions } = useAPI<
    Transaction[]
  >(paymentService.getTransactions());

  const { data: cards, loading: cardsLoading } = useAPI<VirtualCardResponse[]>(
    getVirtualCard()
  );

  const loading = loadingTransactions || cardsLoading;
  const highnoteCard = cards?.find(
    (card) => card.provider.toLowerCase() === "highnote"
  );

  function paymentsSectionTitleSkeleton() {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Skeleton variant="rounded" width="100%" height={92} />
        <Card variant="outlined" sx={{ border: "none" }}>
          <List disablePadding>
            {/* Date header skeleton */}
            <Skeleton
              variant="text"
              height={24}
              width="25%"
              sx={{
                ml: 2,
                mt: 2,
                mb: 1,
              }}
            />

            {/* Transaction items skeleton */}
            {[1, 2].map((index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 1,
                  py: 1,
                  pr: 1.5,
                }}
              >
                {/* Avatar skeleton */}
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ mr: 1, flexShrink: 0 }}
                />

                {/* Content skeleton */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  {/* Primary content - title and amount */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 0.5,
                    }}
                  >
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width="20%" height={20} />
                  </Box>

                  {/* Secondary content - description */}
                  <Skeleton variant="text" width="40%" height={16} />
                </Box>
              </Box>
            ))}
          </List>
        </Card>
      </Box>
    );
  }

  function emptyTransactions() {
    return (
      <Card variant="outlined" sx={{ border: "none" }}>
        <Typography
          py={4}
          px={2}
          textAlign="center"
          variant="body1"
          color="text.secondary"
        >
          {t("payments_empty")}
        </Typography>
      </Card>
    );
  }

  if (loading) return paymentsSectionTitleSkeleton();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {highnoteCard && <ManageCard data={highnoteCard} showButton={false} />}
      {transactions && transactions.length > 0 ? (
        <TransactionsList transactions={transactions} />
      ) : (
        emptyTransactions()
      )}
    </Box>
  );
}

export default CardBalanceAndHistory;
